import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { DEPARTMENT_ACCESS, IMemberList, IDepartmentList } from '@umu/umu-types';
import { IDepartListParam } from './interface';

export interface ISubDepartListInfo {
    department_id: string;
    member_count: string;
    department_name: string;
    parent_department_id: string;
    enterprise_show_name?: string;
    managers: IMemberList[];
    child_path: IDepartmentList[];
    parent_path: IDepartmentList[];
}
export interface IManageDepartmentListParam {
    type?: DEPARTMENT_ACCESS;
}
export interface IManageDepartmentInfo {
    id: string;
    name: string;
    path: {
        id: string;
        name: string;
    }[];
}
export const getSubDepartmentList = (data: IDepartListParam): Promise<ISubDepartListInfo> => {
    if (data.type === DEPARTMENT_ACCESS.ADMIN) {
        delete data.type;
    }
    return fetchData(Api.GET_SUB_DEPARTMENT_LIST, data).then((res: IResponse<ISubDepartListInfo>) => {
        return res.data;
    });
};
export const getManageDepartmentList = (data: IManageDepartmentListParam): Promise<IManageDepartmentInfo[]> => {
    if (data.type === DEPARTMENT_ACCESS.ADMIN) {
        delete data.type;
    }
    return fetchData(Api.GET_MANAGE_DEPARTMENT_LIST, data).then(
        (res: IResponse<IList<IManageDepartmentInfo>>) => {
            return res?.data?.list || [];
        },
        () => {
            return [];
        },
    );
};

interface IManager {
    name: string;
    number: string;
    user_info: IUserInfo;
    role_type: string;
    on_job_status: string;
}
export const getManagersById = (id: string): Promise<IManager[]> => {
    return fetchData(Api.GET_MANAGERS_BY_ID, {
        department_id: id,
    }).then(
        (res: IResponse<IManager[]>) => {
            return res?.data || [];
        },
        () => {
            return [];
        },
    );
};
